import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-live-assistant"
export default class extends Controller {
  static targets = [
    "screenWidth",
    "screenHeight",
    "iframe",
    "url"
  ]

  connect() {
  }

  resizeIframe(e) {
    this.iframeTarget.style.width = `${this.screenWidthTarget.innerText}px`
    this.iframeTarget.style.height = `${this.screenHeightTarget.innerText}px`
  }
}
